import {
  GET_SEARCH_EXTERNAL_INVOICE_REQUEST,
  GET_SEARCH_EXTERNAL_INVOICE_SUCCESS,
  GET_SEARCH_EXTERNAL_INVOICE_ERROR
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const searchExternalInvoice = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEARCH_EXTERNAL_INVOICE_REQUEST });
  const newData = {
    external_invoice_no: values.external_invoice_no || values
};
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/ExternalInvoiceInfoSearch`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEARCH_EXTERNAL_INVOICE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEARCH_EXTERNAL_INVOICE_ERROR,
        payload: [],
      });
    });
};
